module.exports = __webpack_public_path__ + "static/img/高源.a9361f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/st/高源.jpg
// module id = jTL5
// module chunks = 1